import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.s6p_1 = partyId;
        this.t6p_1 = playerId;
        this.u6p_1 = name;
        this.v6p_1 = email;
        this.w6p_1 = badge;
        this.x6p_1 = callSignAdjective;
        this.y6p_1 = callSignNoun;
        this.z6p_1 = imageURL;
        this.a6q_1 = avatarType;
        this.b6q_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.s6p_1.toString() + ', playerId=' + this.t6p_1.toString() + ', name=' + this.u6p_1 + ', email=' + this.v6p_1 + ', badge=' + this.w6p_1.toString() + ', callSignAdjective=' + this.x6p_1 + ', callSignNoun=' + this.y6p_1 + ', imageURL=' + toString(this.z6p_1) + ', avatarType=' + toString(this.a6q_1) + ', unvalidatedEmails=' + toString(this.b6q_1) + ')';
      }
      hashCode() {
        var result = this.s6p_1.hashCode();
        result = imul(result, 31) + this.t6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.u6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.v6p_1) | 0;
        result = imul(result, 31) + this.w6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.x6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y6p_1) | 0;
        result = imul(result, 31) + hashCode(this.z6p_1) | 0;
        result = imul(result, 31) + hashCode(this.a6q_1) | 0;
        result = imul(result, 31) + hashCode(this.b6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.s6p_1.equals(other.s6p_1))
          return false;
        if (!this.t6p_1.equals(other.t6p_1))
          return false;
        if (!(this.u6p_1 === other.u6p_1))
          return false;
        if (!(this.v6p_1 === other.v6p_1))
          return false;
        if (!this.w6p_1.equals(other.w6p_1))
          return false;
        if (!(this.x6p_1 === other.x6p_1))
          return false;
        if (!(this.y6p_1 === other.y6p_1))
          return false;
        if (!equals(this.z6p_1, other.z6p_1))
          return false;
        if (!equals(this.a6q_1, other.a6q_1))
          return false;
        if (!equals(this.b6q_1, other.b6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
